import { Sparkles } from '@deckspace/ui';
import type { SSEConnectionStatus } from '@deckspace/client';

export interface WorkspaceEmptyProps {
  variant: 'no-pages' | 'no-surface';
  connectionStatus: SSEConnectionStatus;
}

const HEADLINES = {
  'no-pages': 'Chat with Claude to begin',
  'no-surface': 'This page is empty',
} as const;

const BODY = {
  'no-pages':
    "Deckspace surfaces are created by Claude. Open a Claude chat and ask for a chart, table, or dashboard — it'll appear here.",
  'no-surface': 'Ask Claude to add a chart, table, or dashboard.',
} as const;

const CHIP_LABEL: Record<SSEConnectionStatus, string> = {
  connecting: 'Realtime: connecting…',
  connected: 'Realtime: connected',
  disconnected: 'Realtime: disconnected',
  error: 'Realtime: error',
};

const CHIP_CLASS: Record<SSEConnectionStatus, string> = {
  connecting: 'bg-muted text-muted-foreground',
  connected: 'bg-primary/10 text-primary',
  disconnected: 'bg-destructive/10 text-destructive',
  error: 'bg-destructive/10 text-destructive',
};

export function WorkspaceEmpty({ variant, connectionStatus }: WorkspaceEmptyProps) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 px-6 text-center">
      <Sparkles className="h-12 w-12 text-muted-foreground" aria-hidden="true" />
      <h2 className="text-xl font-semibold text-foreground">{HEADLINES[variant]}</h2>
      <p className="max-w-md text-sm text-muted-foreground">{BODY[variant]}</p>
      <span
        className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ${CHIP_CLASS[connectionStatus]}`}
      >
        {CHIP_LABEL[connectionStatus]}
      </span>
    </div>
  );
}
